import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { KWizard, KWizardOptions, KlaimSchemaMapperService, KWizardActionsPosition, KWizardActionsDisplay, IKWizardMapper, KWizardService } from 'ng-k-wizard';
import { KListItem, KUtilsService as Utils } from 'ng-k-utils';
import { KInputType } from 'ng-k-form';
import { ClaimsService } from '../../services/claims.service';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { group } from 'console';
import { KButtonType, KKcgButtonSubType } from 'ng-k-button';
import { KNotificationType, KNotificationsService } from 'ng-k-notifications';
import { GlobalLoadingService } from 'src/app/services/global-loading.service';
import { OauthPlusService } from 'src/app/services/oauth-plus.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {
  showWizard = false;
  KButtonType = KButtonType;
  KKcgButtonSubType = KKcgButtonSubType;
  public wizardData!: KWizard;
  public wizardId = '';
  public wizardOptions!: KWizardOptions;
  public claimId = '';
  public schema: any;
  public isFirst: boolean = true;
  public displaySuccess: boolean = false;
  public displayError: boolean = false;
  public successText!: string;
  public errorText!: string;
  public timeout!: number;
  public currentFormType: any;
  public solicitorList: any[] = [];
  public customData: any;
  public conditions = [
    { conditionValue: 'asbestosis', conditionLabel: 'Asbestosis' },
    { conditionValue: 'carcinoma-of-the-lung', conditionLabel: 'Carcinoma of the Lung' },
    { conditionValue: 'mesothelioma', conditionLabel: 'Mesothelioma' },
    { conditionValue: 'nihl', conditionLabel: 'NIHL' },
    { conditionValue: 'pleural-thickening', conditionLabel: 'Pleural Thickening' }
  ];

  constructor(
    private mapper: KlaimSchemaMapperService,
    private http: HttpClient,
    private claimsService: ClaimsService,
    private route: ActivatedRoute,
    private router: Router,
    private notificationsService: KNotificationsService,
    private _auth: OauthPlusService,
    private loaderService: GlobalLoadingService,
    private kWizardSrv: KWizardService
  ) { }

  ngOnInit(): void {
    this.wizardId = Date.now().toString();
    // setting the pixels of header
    this.notificationsService.$initialPixelHeadValue.next(60);
    this.route.params.subscribe(params => {
      if (params['claimId']) {
        this.claimId = decodeURIComponent(params['claimId']);
      }
    });

    this.wizardOptions = {
      action: KWizardActionsPosition.bottom,
      actionsDisplay: KWizardActionsDisplay.all,
      showSteps: true,
      extraClass: 'customWizard'
    };

    this._auth.$whenUserLoaded.subscribe(data => {
      if (data) {
        if (this.claimId) {
          this.currentFormType = 'Edit';
          this.getClaimById(this.claimId);
        } else {
          this.customData = {};
          this.currentFormType = 'New';
          this.loaderService.startLoadingIndicator('getClaimForm');
          this.claimsService.getClaimForm().subscribe(schema => {
            if (schema.status === 'Success') {
              this.loaderService.stopLoadingIndicator('getClaimForm');
              // console.log(schema.data.groups)
              let newgrp = {
                'name': 'solicitorDetails',
                'heading': 'Solicitor Details',
                'icon': 'claimant',
                'fields': [
                  {
                    "name": "solicitorName",
                    "type": "string",
                    "display": "combobox",
                    "label": "Solicitor Name",
                    "helpText": "Solicitor Name",
                    "tooltipText": "Solicitor Name",
                    // "list": this.getSolicitorList(),
                    "source":environment.apiUrl + "claims/solicitor-list",
                    "optionsLookupPath":"data",
                    "hideNoData": false,
                    "validation": {
                      "mandatory": true
                    }
                  },
                  {
                    "name": "solicitorReference",
                    "type": "string",
                    "display": "string",
                    "label": "Solicitor Reference",
                    "validation": {
                      "mandatory": true,
                      "regex": "^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/\\?~\\s]{1,30}$",
                      "regexMessage": "Solicitor Reference input must be Alphanumeric and special characters. Max 30 characters"
                    }
                  },
                  {
                    "name": "solicitorEmail",
                    "type": "string",
                    "display": "string",
                    "label": "Solicitor Email",
                    "validation": {
                      "mandatory": false,
                    }
                  },
                  {
                    "name": "telephone",
                    "type": "string",
                    "display": "string",
                    "label": "Telephone",
                    "validation": {
                      "mandatory": false,
                      "regex": "^[0-9]*$",
                      "regexMessage": "Enter valid phone number"
                    }
                  },
                  {
                    "name": "address",
                    "type": "string",
                    "display": "textarea",
                    "label": "Address",
                    "validation": {
                      "mandatory": false
                    }
                  },
                  {
                    "name": "town",
                    "type": "string",
                    "display": "string",
                    "label": "City / Town",
                    "validation": {
                      "mandatory": true,
                      "regex": "^[a-zA-Z]+(\\s{0,1}[a-zA-Z])+$",
                      "regexMessage": "Only alphabets allowed"
                    }
                  },
                  {
                    "name": "postCode",
                    "type": "string",
                    "display": "text",
                    "label": "Post Code",
                    "validation": {
                      "mandatory": true,
                      "regex": "^[a-zA-Z0-9 ]+$",
                      "regexMessage": "Post Code input must contain only alphanumeric, with an optional single space between words."
                    }
                  }
                ],
                'groups': [],
                'triggers': []
              };
              // schema.data.groups.push(newgrp);

              for (let group of schema.data.groups) {
                if (group.name == 'claimantDetails') {
                  for (let field of group.fields) {
                    if (field.name == 'telephone') {
                      field['type'] = "string";
                      field['display'] = 'string';
                      field['validation'] = {
                        "mandatory": false,
                        "regex": "^[0-9]*$",
                        "regexMessage": "Enter valid phone number"
                      }
                    }
                  }
                  // console.log(group.triggers);    
                  // let triggers:any = 
                  //   {                      
                  //   }
                  // group.triggers.push(triggers);
                }
                if (group.name == 'claimDetails') {
                  for (let field of group.fields) {
                    if (field.name == 'jurisdiction') {
                      field['visible'] = false;
                      // console.log(field.validation)
                      // let customValidation: any = {
                      //   'min':10,
                      //   'minMessage':'Value cannot be 0. Please enter correct value'
                      // }
                      // field.validation = customValidation;
                    }
                  }

                  let triggers: any =
                  {
                    'type': 'custom',
                    'function': 'checkCondition',
                    'trigger': 'condition'
                  };
                  group.triggers.push(triggers);
                }
              }
              this.schema = schema;

              for (let group of this.schema.data.groups) {
                group.description = 'New Claim';
              }
              if (Utils.isDefined(schema.data.groups) && schema.data.groups.length > 0) {
                schema.data.groups.map((group: any) => {
                  if (group == 'claimDetails') {
                  }
                  this.addFunctionToTrigger(group);
                });
              }

              for (let group of schema.data.groups) {
                if (group.name == 'claimDetails') {
                }
              }

              this.addTriggers(); // adding dropdown field options
              this.wizardFieldMutation()
              this.wizardData = this.mapper.mapToWizard(this.schema, this.wizardId);

            }
          });


          // this.http.get('https://10.100.118.194:3000/api/v1/claims/form').subscribe((schema: any) => {
          // this.http.get('./../assets/sample.json').subscribe((schema: any) => {
          // console.log(schema.groups );
          // schema.groups = schema.groups.map((item: any)=> {
          //   console.log(item);
          //   if (item.triggers) {
          //     item.triggers = item.triggers.map((trigger: any) => {
          //       console.log(trigger);
          //       if(trigger.function) {
          //         let that: any=this;
          //         trigger['realFunction'] = that[trigger.function].bind(this);
          //         if( !trigger['realFunction']) {
          //           trigger['realFunction'] = () => {};
          //         }
          //       }

          //       return trigger;
          //     })
          //   }

          //   return item;
          // })
          //   this.addListData(schema); // addi ng dropdown field options
          //   this.schema = schema;
          //   this.wizardData = this.mapper.mapToWizard(schema, this.wizardId);
          // });
        }
      }
    });
  }

  getSolicitorList() {
    this.solicitorList = [];
    this.loaderService.startLoadingIndicator('getSolicitorList');
    const thisObj = this;
    let requestParam: any = {};
    thisObj.claimsService.getSolicitorList(requestParam).subscribe(
      {
        next: (result) => {
          let temp: any;
          result.data.forEach((solicitorName: any) => {
            temp = {
              "label": solicitorName,
              "value": solicitorName
            }
            this.solicitorList.push(temp);
          });
          this.loaderService.stopLoadingIndicator('getSolicitorList');
          // return solicitorList;
        },
        error: (err) => {
          console.log(err);
          this.errorText = err.message;
          this.loaderService.stopLoadingIndicator('saveLimitationParams');
        }
      });
    return this.solicitorList;
  }

  wizardFieldMutation(claimId?: any): void {
    if (!claimId) {
      //set dob to current date for fix error triggered by KUI
      this.schema.data.flexData.claimantDetails.dateOfBirth = new Date();
    } else {
      this.schema.data.flexData.claimantDetails.dateOfBirth = new Date(this.schema.data.flexData.claimantDetails.dateOfBirth);
    }
    this.schema.data.groups.forEach((group: any) => {
      if (group.name == "claimantDetails") {
        group.fields.forEach((field: any) => {
          if (field.name == 'dateOfBirth') {
            field.validation["maxDate"] = new Date();
          }
          if (field.name == 'claimantFirstName' || field.name == 'claimantLastName') {
            field.validation["regex"] = "^[a-zA-Z]+(\\s{0,1}[a-zA-Z])+$";
            field.validation["regexMessage"] = field.label + " input must contain only alphabets, with an optional single space between words.";
          }
        });
      }

      if (group.name == "solicitorDetails") {
        group.fields.forEach((field: any) => {
          if (field.name == 'solicitorName') {
            field.limitOptionsLength = true;
            field.source = environment.apiUrl + "claims/solicitor-list";
            field.optionsLookupPath = "data";
            field.hideNoData = false;
            field.allowNewValues = true;
            //field.list = this.getSolicitorList();
            field.validation["regex"] = "^(?!^[^a-zA-Z0-9]*$)(?!.*\s{2}).{10,35}$";
            field.validation["regexMessage"] = field.label + " input must contain only alphanumeric characters and allowed special characters, with an optional single space between words, and length between 10 to 35 characters.";
          }
          if (field.name == 'solicitorReference') {
            field.validation["regex"] = "^$|^[a-zA-Z0-9!@#$%^&*()_+\\-=\\[\\]{};':\"\\\\|,.<>\\/\\?~\\s]{1,30}$";
            field.validation["regexMessage"] = field.label + " input must be Alphanumeric and special characters. Max 30 characters";
          }
          if (field.name == 'solicitorEmail') {
            field.validation["regex"] = "/^$|[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-z0-9](?:[a-z0-9-]*[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]*[a-z0-9])?)+$/";
            field.validation["regexMessage"] = "Enter valid " + field.label;
          }
          if (field.name == 'solicitorTelephone') {
            field.validation["regex"] = "^[0-9]*$";
            field.validation["regexMessage"] = "Enter valid " + field.label;
          }
          if (field.name == 'solicitorCity') {
            field.validation["regex"] = "^([a-zA-Z]+( [a-zA-Z]+)*)?$";
            field.validation["regexMessage"] = field.label + " - Only alphabets allowed";
          }
          if (field.name == 'solicitorPostCode') {
            field.validation["regex"] = "^([a-zA-Z0-9]+( [a-zA-Z0-9]+)*)?$";
            field.validation["regexMessage"] = field.label + " input must contain only alphanumeric, with an optional single space between words.";
          }
        });
      }
    });
  }
  /**
   * Iterate through the groups inside a group and add correct functions to triggers of type 'custom'
   * @param group group data from schema json
   */
  public addFunctionToTrigger(group: any) {
    // console.log(group.triggers)
    if (Utils.isDefined(group.triggers) && group.triggers.length > 0) {
      if (group.triggers) {
      }
      group.triggers.map((trigger: any) => {
        if (trigger.type === 'custom' && Utils.isDefined(trigger.function)) {
          let that: any = this;
          trigger.realFunction = that[trigger.function];
        }
      });
    }
    // if (Utils.isDefined(group.groups) && group.groups.length > 0) {
    //   group.groups.map((subGrp) => {
    //     this.addFunctionToTrigger(subGrp);
    //   });
    // }
  }

  addTriggers() {
    let { data } = this.schema;
    let { groups } = data;
    groups[1]["triggers"] = [
      {
        "type": "custom",
        //"function": "changeCurrency",
        "trigger": "jurisdiction",
        "realFunction": (ev: any, param: any) => {
          this.changeCurrency(ev.steps[1].fieldGroups[0].fields[1].value)
        }
      },
      // {
      //   "type": "custom",
      //   "function": "checkCondition",
      //   "trigger": "condition",
      //   "realFunction": () => {
      //     groups[1]['fields'][2] = {
      //       visible: false,
      //       ...groups[1]['fields'][2]
      //     }
      //     if(!this.isFirst){
      //       this.wizardData = this.mapper.mapToWizard(this.schema, this.wizardId);
      //       this.isFirst = true;
      //     } else {
      //       this.isFirst = false;
      //     }
      //   }
      //},
    ],
      groups[2]["triggers"] = [
        // {
        //   "type": "custom",
        //   "trigger": "solicitorName",
        //   "realFunction": this.getFunction('updateSolicitorReference','solicitorDetails')
        // }
        {
          "type": "custom",
          "trigger": "solicitorName",
          "realFunction": this.getFunction('trimSpace', 'solicitorDetails')
        }
      ]
  }

  getFunction(functionName: string, groupName: string) {
    // console.log(typeof this[functionName as keyof WizardComponent])
    if (typeof this[functionName as keyof WizardComponent] === 'function') {
      return (wizardData: KWizard) => {
        (this[functionName as keyof WizardComponent] as Function)(wizardData, groupName);
      };
    }
    return () => { };
  }

  updateSolicitorReference(wizardData: KWizard, groupName: string) {
    const step = this.kWizardSrv.getStep(wizardData, groupName);
    const group = this.kWizardSrv.getGroup(step, groupName);

    const solicitorNameField = this.kWizardSrv.getField(group, 'solicitorName');
    const solicitorReferenceField = this.kWizardSrv.getField(group, 'solicitorReference');

    if (solicitorNameField.value != null) {
      console.log(solicitorNameField.value)
      console.log('solicitor name is not null')

      solicitorReferenceField.setValue('tsdssxt');
      console.log(solicitorReferenceField.value);
    }
  }

  trimSpace(wizardData: KWizard, groupName: string) {
    const step = this.kWizardSrv.getStep(wizardData, groupName);
    const group = this.kWizardSrv.getGroup(step, groupName);

    const solicitorNameField = this.kWizardSrv.getField(group, 'solicitorName');
    if (solicitorNameField.value != null) {
      let temp = solicitorNameField.value.replace(/\s+/g, ' ').trim();
      solicitorNameField.setValue(temp);
    }
  }


  /**
   * Add dropdown data to the fields
   * @param data data read from json
   */
  public addListData(data: any) {
    data = this.sanitizeData(data);

    if (Utils.isDefined(data.groups) && data.groups.length > 0) {
      data.groups.map((group: any) => {
        this.addListToField(group);
      });
    }
  }

  sanitizeData(data: any) {
    if (Utils.isDefined(data.data)) {
      // data contains data, so data should take the form of data.data
      data = data.data;
    }
    return data;
  }

  /**
   * Iterate through the fields/ groups inside a group add list to the field level
   * @param group group data from schema json
   */
  public addListToField(group: any) {
    if (Utils.isDefined(group.fields) && group.fields.length > 0) {
      group.fields.map((field: { listCode: any; list: any; }) => {
        if (this.isFieldNeedOptions(field) && Utils.isDefined(field.listCode)) {
          field.list = this.getLists(field.listCode);
        }
      });
    }
    if (Utils.isDefined(group.groups) && group.groups.length > 0) {
      group.groups.map((subGrp: any) => {
        this.addListToField(subGrp);
      });
    }
  }

  isFieldNeedOptions(field: any) {
    const fieldWithOptions = [KInputType.dropdown, KInputType.checkbox, KInputType.radio, KInputType.combobox];
    return fieldWithOptions.includes(field.display);
  }

  changeCurrency(country: string) {
    let currencySymbol = country == 'United Kingdom' ? '£' : '$';
    let el = document.querySelector('k-money-input > div > div');
    if (el) {
      el.innerHTML = currencySymbol;
    }
  }

  /**
   * NOTE: Just for demo only
   * get lists based on the list code
   * @param listCode list code string
   */
  private getLists(listCode: string) {
    switch (listCode) {
      case 'biologicalSex':
        return this.mapListValues([
          { name: 'Female', value: 'female' },
          { name: 'Male', value: 'male' }
        ]);
      case 'countryCodes':
        return this.mapListValues([
          { name: '+41', value: '+41' },
          { name: '+91', value: '+91' },
        ]);
      default:
        return this.mapListValues([
          { name: 'option 1', value: 1 },
          { name: 'option 2', value: 2 },
          { name: 'option 3', value: 3 },
          { name: 'option 4', value: 4 },
          { name: 'option 5', value: 5 }
        ]);
    }
  }

  /**
   * Map list to dropdown options model
   * @param listValues dropdown options array
   */
  private mapListValues(list: any[]) {
    if (Utils.isDefined(list)) {
      return list.map(x => ({ label: x.name, value: x.value }));
    } else {
      return undefined;
    }
  }

  /**
   * Handles action
   * @param event btn action event
   */
  handleAction(event: any) {
    switch (event.type) {
      case 'Save': {
        // Map from schema to correct type (docs/decision)
        // const data = this.mapper.mapGroupFromWizard(event.data);
        // console.log(this.wizardData);
        // console.log(this.schema);
        let finalData: any = {};
        for (let g of this.wizardData.steps) {
          if (g.name == 'claimDetails') {
            for (let fg of g.fieldGroups) {
              for (let f of fg.fields) {
                if (f.label == 'Jurisdiction') {
                  f.value = 'United Kingdom';
                }
              }
            }
          }

          if (g.name == 'solicitorDetails') {
          }
          // console.log(this.mapper.mapGroupFromWizard(g.fieldGroups[0]));
          finalData[g.name] = this.mapper.mapGroupFromWizard(g.fieldGroups[0]);
        }
        // console.log(finalData)
        this.saveClaim(finalData);
        // let elem : any = document.querySelector('[ng-reflect-label="Save"] > button');
        let elem: any = document.querySelector('.kennedys-wizard-action-buttons :nth-child(3) button.klaim_btn');
        if (elem) {
          elem.disabled = true;
        }
        return;
        break;
      }
      case 'Cancel': {
        this.router.navigate(['/claims/']);
        break;
      }
    }
  }

  stopWizard() {
    this.showWizard = false;
  }

  saveClaim(data: any) {
    const thisObj = this;
    const requestParam: any = {};
    let temp: any[] = [];
    requestParam.claimId = this.claimId ? this.claimId : null;
    console.log(data.employmentHistory.employmentHistory)
    for (let eh of data.employmentHistory.employmentHistory) {
      // console.log((eh.employer))
      if (!eh.employer && !eh.employmentFrom && !eh.employmentTo && !eh.insurerReference) {
      } else {
        temp.push(eh);
      }
      console.log(temp)
    }
    if (temp.length >= 1) {
      data.employmentHistory.employmentHistory = temp;
    } else {
      data.employmentHistory.employmentHistory = [{}];
    }
    requestParam.claimData = data;

    if (this.claimId) {
      thisObj.claimsService.editClaim(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.successText = 'Edited claim successfully';
          this.showMessage('success', 2000);
          setTimeout(() => {
            this.router.navigate(['/claimDetail/', encodeURIComponent(this.claimId)]);
          }, 2020);
          // this.notificationsService.notify(KNotificationType.success, msgType, `example of ${msgType} notification`);
        }
      },
        err => {
          console.log('err')
          console.log(err.error.data[0].message);
          this.errorText = err.error.data[0].message;
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.displayError = false;
          }, 2001);
          // let elem : any = document.querySelector('[ng-reflect-label="Save"] > button');
          let elem: any = document.querySelector('.kennedys-wizard-action-buttons :nth-child(3) button.klaim_btn');
          if (elem) {
            elem.disabled = false;
          }
        });
    } else {
      thisObj.claimsService.saveClaim(requestParam).subscribe(result => {
        if (result.status === 'Success') {
          this.successText = 'Saved new claim';
          this.showMessage('success', 2000)
          setTimeout(() => {
            this.router.navigate(['/claimDetail/', encodeURIComponent(result.data.claimId)]);
          }, 2020);
        }
      },
        err => {
          console.log('err')
          console.log(err.error);
          // this.loaderService.stopLoadingIndicator('getTableData');
          this.errorText = err.error.data[0].message;
          this.showMessage('error', 2000);
          setTimeout(() => {
            this.displayError = false;
          }, 2001);
          // let elem : any = document.querySelector('[ng-reflect-label="Save"] > button');
          let elem: any = document.querySelector('.kennedys-wizard-action-buttons :nth-child(3) button.klaim_btn');
          if (elem) {
            elem.disabled = false;
          }
        });
    }
  }

  getClaimById(claimID: any) {
    this.loaderService.startLoadingIndicator('getClaimById');
    const requestParam: any = {};
    requestParam.claimId = claimID;
    this.claimsService.getClaimById(requestParam).subscribe({
      next: result => {
        if (result.status === 'Success') {
          this.loaderService.stopLoadingIndicator('getClaimById');
          this.schema = result;
          this.customData =
          {
            claimId: this.claimId,
            claimantName: result.data.flexData.claimantDetails.claimantFirstName + " " + result.data.flexData.claimantDetails.claimantLastName,
            medicalConditionLabel: this.conditions[result.data.flexData.claimDetails.condition-1].conditionLabel,
            medicalConditionValue: this.conditions[result.data.flexData.claimDetails.condition-1].conditionValue
          }
          for (let group of this.schema.data.groups) {
            group.description = 'Edit Claim';
            if (group.name == 'claimantDetails') {
              for (let field of group.fields) {
                if (field.name == 'telephone') {
                  field['type'] = "string";
                  field['display'] = 'string';
                  field['validation'] = {
                    "mandatory": false,
                    "regex": "^[0-9]*$",
                    "regexMessage": "Enter valid phone"
                  }
                }
              }
            } else
              if (group.name == 'claimDetails') {
                for (let field of group.fields) {
                  if (field.name == 'jurisdiction') {
                    field['visible'] = false;
                    // console.log(field.validation)
                    // let customValidation: any = {
                    //   'min':10,
                    //   'minMessage':'Value cannot be 0. Please enter correct value'
                    // }
                    // field.validation = customValidation;
                  }
                }
              }
          }
          if (this.schema) {
            this.addTriggers();
          }
          this.wizardFieldMutation(claimID);
          this.wizardData = this.mapper.mapToWizard(this.schema, this.wizardId);
          // setTimeout(() => this.changeCurrency('United States'), 1000)
        }
      },
      error: err => {
        this.loaderService.stopLoadingIndicator('getClaimById');
      }
    });
  }

  checkCondition(wizardData: any) {
    // if (Utils.isDefined(wizardData)) {
    //   const step = wizardData.steps.filter((s) => s.name === 'CourtDetails')[0];
    //   const group = step.fieldGroups.filter((g) => g.name === 'CourtDetails')[0];
    //   const field = group.fields.filter((f) => f.name === 'SelectCourt')[0];
    //   alert(`selected court:`);
    // }
    if (Utils.isDefined(wizardData)) {
      const step = wizardData.steps.filter((s: any) => s.name === 'claimDetails')[0];
      const group = step.fieldGroups.filter((g: any) => g.name === 'claimDetails')[0];
      const field = group.fields.filter((f: any) => f.name === 'condition')[0];
      // console.log(`selected condition:  ${field.value}`);
    }
  }

  checkJurisdiction($event: any) {
    // console.log(this.schema);
  }

  goToPage() {
    this.router.navigate(['/claimDetail/', this.claimId]);
    // window.history.back();
  }

  public showMessage(msgType: any, timeout: any) {
    this.displaySuccess = false;
    if (msgType === 'success') {
      this.displaySuccess = true;
    }
    if (msgType === 'error') {
      this.displayError = true;
    }
    if (timeout) {
      this.timeout = timeout;
    }
  }
}
